import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

function App() {
  return (
    <div className="relative min-h-screen flex flex-col bg-[var(--color-background-main)]">
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,var(--color-primary-main)/15%,transparent_50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,var(--color-primary-main)/10%,transparent_30%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_60%,var(--color-primary-main)/8%,transparent_40%)]" />
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[var(--color-primary-main)]/10 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute top-3/4 right-1/4 w-64 h-64 bg-[var(--color-primary-main)]/5 rounded-full blur-2xl animate-pulse" />
        <div className="absolute inset-0 opacity-5 mix-blend-overlay bg-[radial-gradient(at_50%_50%,var(--color-text-main)/10%,var(--color-background-main)/50%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,transparent_20%,var(--color-background-main)/40%_150%)]" />
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0 bg-gradient-to-b from-transparent via-[var(--color-primary-main)]/10 to-transparent animate-pulse"
            style={{ backgroundSize: '100% 400px', backgroundPosition: '0px -100px' }}
          />
          <div
            className="absolute inset-0 bg-gradient-to-r from-transparent via-[var(--color-primary-main)]/10 to-transparent animate-pulse-slow"
            style={{ backgroundSize: '400px 100%', backgroundPosition: '-100px 0px' }}
          />
        </div>
        <div className="absolute top-0 left-1/4 w-1/2 h-1/2 bg-gradient-to-br from-[var(--color-primary-main)]/20 to-transparent blur-3xl animate-pulse-slow" />
        <div className="absolute bottom-0 right-1/4 w-1/2 h-1/2 bg-gradient-to-tl from-[var(--color-primary-main)]/10 to-transparent blur-3xl animate-pulse" />
      </div>
      <div className="relative flex-1 flex flex-col">
        <div className="sticky top-0 z-50 glass-effect border-b border-white/10 shadow-lg bg-[var(--color-background-main)] app-header">
          <a href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502698" target="_blank" rel="noopener noreferrer" className="block group">
            <div className="bg-gradient-to-r from-primary-600 via-primary-500 to-primary-400 p-1.5 relative overflow-hidden shadow-md hover:shadow-glow-lg transition-all duration-300">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.15),transparent)] pointer-events-none" />
              <div className="absolute inset-0 overflow-hidden">
                <div className="absolute w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
              </div>
              <div className="flex items-center justify-between relative z-10 max-w-7xl mx-auto px-2">
                <div className="flex items-center space-x-1.5">
                  <div className="w-5 h-5 rounded-md flex items-center justify-center">
                    <img src="icons/header.webp" alt="Bonus" className="w-5 h-5 object-contain drop-shadow-lg" />
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-xs leading-tight drop-shadow-md">Betrupi 250₺ Çekim Limitsiz Deneme Bonusu</h3>
                  </div>
                </div>
                <div className="flex items-center space-x-1 bg-white/90 text-primary-600 px-1.5 py-0.5 rounded text-[9px] font-semibold shadow-sm group-hover:bg-white transition-all duration-300">
                  <span>Bonusu Al</span>
                </div>
              </div>
            </div>
          </a>
        </div>

        <main className="flex-1 max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8 pb-32 overflow-y-auto">
          <div className="py-1">
            <div className="space-y-2">
              <div className="space-y-1.5">
                <div className="flex items-center justify-center gap-2 py-1">
                  <div className="h-px flex-1 bg-gradient-to-r from-transparent to-yellow-500/40" />
                  <span className="text-[10px] font-black tracking-widest text-yellow-400/90 uppercase">Premium Siteler</span>
                  <div className="h-px flex-1 bg-gradient-to-l from-transparent to-yellow-500/40" />
                </div>
                <a
                  href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502698"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block group relative overflow-hidden rounded-2xl border border-yellow-400/70 transition-all duration-300 active:scale-[0.98] touch-manipulation"
                  style={{ height: '105px' }}
                >
                  <img
                    src="slider/rupi.gif"
                    alt=""
                    className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700"
                  />
                </a>
                <a
                  href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502697"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block group relative overflow-hidden rounded-2xl border border-yellow-400/70 transition-all duration-300 active:scale-[0.98] touch-manipulation"
                  style={{ height: '105px' }}
                >
                  <img
                    src="slider/getto.gif"
                    alt=""
                    className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-700"
                  />
                </a>
              </div>
              <div className="overflow-hidden rounded-xl bg-[var(--color-background-card)] border border-white/5 shadow-2xl">
                <div className="px-3 py-1.5 border-b border-white/5">
                  <div className="flex items-center justify-center gap-2">
                    <div className="h-px flex-1 bg-gradient-to-r from-transparent to-white/20" />
                    <h2 className="text-[10px] font-black tracking-widest text-white/80 uppercase">Trend Siteler</h2>
                    <div className="h-px flex-1 bg-gradient-to-l from-transparent to-white/20" />
                  </div>
                </div>
                <div className="overflow-hidden">
                  <div className="rounded-xl overflow-hidden bg-[var(--color-background-card)] shadow-2xl">
                    <a
                      href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502698"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="relative flex items-center px-2 py-0.5 transition-all duration-200 group hover:bg-gradient-to-r hover:from-primary-500/10 hover:to-transparent active:bg-primary-500/10"
                    >
                      <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-400 to-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                      <div className="w-[120px] flex-shrink-0">
                        <div className="relative h-[40px] w-[120px]">
                          <div className="relative h-full w-full bg-gradient-to-br from-white/8 to-white/3 rounded-md flex items-center justify-center group-hover:border-primary-500/30 transition-all duration-200 overflow-hidden">
                            <img
                              src="trend/betrupi.png"
                              alt="Casino logo"
                              style={{ padding: '5px' }}
                              className="w-full h-full object-contain transition-transform duration-200 group-hover:scale-105"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 flex flex-col justify-center items-center px-2 min-w-0 self-center w-full">
                        <span className="font-bold text-[11px] bg-gradient-to-r from-white via-primary-200 to-white bg-clip-text text-transparent truncate text-center leading-tight w-full block">250₺ Çekim Limitsiz</span>
                        <span className="text-[9px] text-[var(--color-text-muted)] truncate text-center mt-0.5 w-full block">Deneme Bonusu</span>
                      </div>
                      <div className="flex-shrink-0">
                        <div className="relative overflow-hidden bg-gradient-to-r from-primary-600 to-primary-500 group-hover:from-primary-500 group-hover:to-primary-400 text-white px-3 py-1.5 rounded-md text-[10px] font-bold transition-all duration-200 h-[32px] flex items-center justify-center">
                          <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_25%,rgba(255,255,255,0.3)_50%,transparent_75%)] group-hover:animate-shimmer" />
                          <div className="flex items-center gap-1 relative z-10">
                            <span>Bonusu Al</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mouse-pointer-click">
                              <path d="m9 9 5 12 1.8-5.2L21 14Z" />
                              <path d="M7.2 2.2 8 5.1" />
                              <path d="m5.1 8-2.9-.8" />
                              <path d="M14 4.1 12 6" />
                              <path d="m6 12-1.9 2" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </a>
                    <a
                      href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502697"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="relative flex items-center px-2 py-0.5 transition-all duration-200 group hover:bg-gradient-to-r hover:from-primary-500/10 hover:to-transparent active:bg-primary-500/10 border-t border-white/[0.06]"
                    >
                      <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary-400 to-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                      <div className="w-[120px] flex-shrink-0">
                        <div className="relative h-[40px] w-[120px]">
                          <div className="relative h-full w-full bg-gradient-to-br from-white/8 to-white/3 rounded-md flex items-center justify-center group-hover:border-primary-500/30 transition-all duration-200 overflow-hidden">
                            <img
                              src="trend/gettobet.png"
                              alt="Casino logo"
                              style={{ padding: '5px' }}
                              className="w-full h-full object-contain transition-transform duration-200 group-hover:scale-105"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="flex-1 flex flex-col justify-center items-center px-2 min-w-0 self-center w-full">
                        <span className="font-bold text-[11px] bg-gradient-to-r from-white via-primary-200 to-white bg-clip-text text-transparent truncate text-center leading-tight w-full block">222₺ Çekim Limitsiz</span>
                        <span className="text-[9px] text-[var(--color-text-muted)] truncate text-center mt-0.5 w-full block">Deneme Bonusu</span>
                      </div>
                      <div className="flex-shrink-0">
                        <div className="relative overflow-hidden bg-gradient-to-r from-primary-600 to-primary-500 group-hover:from-primary-500 group-hover:to-primary-400 text-white px-3 py-1.5 rounded-md text-[10px] font-bold transition-all duration-200 h-[32px] flex items-center justify-center">
                          <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_25%,rgba(255,255,255,0.3)_50%,transparent_75%)] group-hover:animate-shimmer" />
                          <div className="flex items-center gap-1 relative z-10">
                            <span>Bonusu Al</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mouse-pointer-click">
                              <path d="m9 9 5 12 1.8-5.2L21 14Z" />
                              <path d="M7.2 2.2 8 5.1" />
                              <path d="m5.1 8-2.9-.8" />
                              <path d="M14 4.1 12 6" />
                              <path d="m6 12-1.9 2" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <div className="app-navigation fixed bottom-0 left-0 right-0 z-50 pointer-events-none">
          <div className="glass-effect border-t border-white/10 shadow-lg pointer-events-auto">
            <a href="https://tracker.getrupiaffiliate.org/link?btag=106683467_502697" target="_blank" rel="noopener noreferrer" className="block group">
              <div className="bg-gradient-to-r from-primary-600 via-primary-500 to-primary-400 p-1.5 relative overflow-hidden shadow-md hover:shadow-glow-lg transition-all duration-300">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(255,255,255,0.15),transparent)] pointer-events-none" />
                <div className="absolute inset-0 overflow-hidden">
                  <div className="absolute w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/10 to-transparent" />
                </div>
                <div className="flex items-center justify-between relative z-10 max-w-7xl mx-auto px-2">
                  <div className="flex items-center space-x-1.5">
                    <div className="w-5 h-5 rounded-md flex items-center justify-center">
                      <img src="icons/footer.webp" alt="Bonus" className="w-5 h-5 object-contain drop-shadow-lg" />
                    </div>
                    <div>
                      <h3 className="text-white font-bold text-xs leading-tight drop-shadow-md">Gettobet 222₺ Çekim Limitsiz Deneme Bonusu</h3>
                    </div>
                  </div>
                  <div className="flex items-center space-x-1 bg-white/90 text-primary-600 px-1.5 py-0.5 rounded text-[9px] font-semibold shadow-sm group-hover:bg-white transition-all duration-300">
                    <span>Bonusu Al</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
